var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"  mb-6"},[_vm._v("Mesas")]),_c('v-row',[_c('v-col',[_c('view-mesas')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }